export const COLUMNS = {
	ID: 'Id',
	CREATED_DATE: 'CREATED_DATE',
	COST_CENTRE: 'COST_CENTRE',
	COST_CENTRE_DESCRIPTION: 'COST_CENTRE_DESCRIPTION',
	GL_CODE: 'GL_CODE',
	GL_DESCRIPTION: 'GL_DESCRIPTION',
	WORKSTREAM: 'WORKSTREAM',
	INITIATIVE: 'INITIATIVE',
	EVP_L1: 'EVP_L1',
	EVP_L2: 'EVP_L2',
	EVP_L3: 'EVP_L3',
	EVP_L4: 'EVP_L4',
	EVP_L5: 'EVP_L5',
	BUDGET_OWNER: 'BUDGET_OWNER',
	BUSINESS_UNIT: 'BUSINESS_UNIT',
	DEPARTMENT: 'DEPARTMENT',
	SITE: 'SITE',
	ORIGINAL_ANNUAL_BUDGET: 'ORIGINAL_ANNUAL_BUDGET',
	FORECAST_ANNUAL_BUDGET: 'FORECAST_ANNUAL_BUDGET',
	ACTUAL_ANNUAL_SPEND: 'ACTUAL_ANNUAL_SPEND',
};

const DEFAULT_MONTH_COUNT = 12;

const getMonthLabelByIndex = index => {
	return `BUDGET/ACTUAL_SPEND_P${index + 1}`;
};

export const getMonthCountFromData = data => {
	if (!data || !data[0]) {
		return DEFAULT_MONTH_COUNT;
	}

	return Object.keys(data[0]).filter(item =>
		item.includes('ACTUAL_SPEND_MONTH')
	).length;
};

export const getColumnDefs = monthCount => [
	{
		headerName: '',
		colId: 'contextualMenu',
		cellRenderer: 'menuCellRenderer',
		editable: false,
		filter: false,
		sortable: false,
		resizable: false,
		width: 50,
		minWidth: 50,
		lockPosition: 'left',
		lockVisible: true,
		suppressColumnsToolPanel: true,
		suppressFiltersToolPanel: true,
	},
	{
		headerName: COLUMNS.COST_CENTRE,
		field: COLUMNS.COST_CENTRE,
		colId: COLUMNS.COST_CENTRE,
	},
	{
		headerName: COLUMNS.COST_CENTRE_DESCRIPTION,
		field: COLUMNS.COST_CENTRE_DESCRIPTION,
		colId: COLUMNS.COST_CENTRE_DESCRIPTION,
		width: 240,
	},
	{
		headerName: COLUMNS.GL_CODE,
		field: COLUMNS.GL_CODE,
		colId: COLUMNS.GL_CODE,
	},
	{
		headerName: COLUMNS.GL_DESCRIPTION,
		field: COLUMNS.GL_DESCRIPTION,
		colId: COLUMNS.GL_DESCRIPTION,
	},
	{
		headerName: COLUMNS.WORKSTREAM,
		field: COLUMNS.WORKSTREAM,
		colId: COLUMNS.WORKSTREAM,
	},
	{
		headerName: COLUMNS.INITIATIVE,
		field: COLUMNS.INITIATIVE,
		colId: COLUMNS.INITIATIVE,
	},
	{ headerName: COLUMNS.EVP_L1, field: COLUMNS.EVP_L1, colId: COLUMNS.EVP_L1 },
	{ headerName: COLUMNS.EVP_L2, field: COLUMNS.EVP_L2, colId: COLUMNS.EVP_L2 },
	{ headerName: COLUMNS.EVP_L3, field: COLUMNS.EVP_L3, colId: COLUMNS.EVP_L3 },
	{ headerName: COLUMNS.EVP_L4, field: COLUMNS.EVP_L4, colId: COLUMNS.EVP_L4 },
	{ headerName: COLUMNS.EVP_L5, field: COLUMNS.EVP_L5, colId: COLUMNS.EVP_L5 },
	{
		headerName: COLUMNS.BUDGET_OWNER,
		field: COLUMNS.BUDGET_OWNER,
		colId: COLUMNS.BUDGET_OWNER,
	},
	{
		headerName: COLUMNS.BUSINESS_UNIT,
		field: COLUMNS.BUSINESS_UNIT,
		colId: COLUMNS.BUSINESS_UNIT,
	},
	{
		headerName: COLUMNS.DEPARTMENT,
		field: COLUMNS.DEPARTMENT,
		colId: COLUMNS.DEPARTMENT,
	},
	{ headerName: COLUMNS.SITE, field: COLUMNS.SITE, colId: COLUMNS.SITE },
	{
		headerName: 'ANNUAL_BUDGET/ACTUAL_SPEND',
		children: [
			{
				headerName: 'ORIGINAL',
				field: COLUMNS.ORIGINAL_ANNUAL_BUDGET,
				colId: COLUMNS.ORIGINAL_ANNUAL_BUDGET,
				type: 'numberColumn',
			},
			{
				headerName: 'FORECAST',
				field: COLUMNS.FORECAST_ANNUAL_BUDGET,
				colId: COLUMNS.FORECAST_ANNUAL_BUDGET,
				type: 'numberColumn',
			},
			{
				headerName: 'ACTUAL_SPEND',
				field: COLUMNS.ACTUAL_ANNUAL_SPEND,
				colId: COLUMNS.ACTUAL_ANNUAL_SPEND,
				type: 'numberColumn',
			},
		],
	},
	...[...new Array(monthCount)].map((_, index) => ({
		headerName: getMonthLabelByIndex(index),
		children: [
			{
				headerName: 'ORIGINAL',
				field: `ORIGINAL_BUDGET_MONTH_${index + 1}`,
				colId: `ORIGINAL_BUDGET_MONTH_${index + 1}`,
				type: 'numberColumn',
			},
			{
				headerName: 'FORECAST',
				field: `FORECAST_BUDGET_MONTH_${index + 1}`,
				colId: `FORECAST_BUDGET_MONTH_${index + 1}`,
				type: 'numberColumn',
			},
			{
				headerName: 'ACTUAL_SPEND',
				field: `ACTUAL_SPEND_MONTH_${index + 1}`,
				colId: `ACTUAL_SPEND_MONTH_${index + 1}`,
				type: 'numberColumn',
			},
		],
	})),
];

export const MANDATORY_COLUMNS = [
	COLUMNS.COST_CENTRE,
	COLUMNS.GL_CODE,
	COLUMNS.BUDGET_OWNER,
];

const numberValueSetter = params => {
	const { newValue, column, oldValue } = params;
	const value = Number(newValue) || 0;

	if (value !== oldValue) {
		params.data[column.colId] = value;

		return true;
	}

	return false;
};

export const COLUMN_TYPES = {
	numberColumn: {
		filter: 'agNumberColumnFilter',
		valueSetter: numberValueSetter,
	},
};

export const UNDO_ACTIONS = {
	EDIT: 'edit',
	CREATE: 'create',
	DELETE: 'delete',
};

const aggregatedColumns = [
	COLUMNS.ORIGINAL_ANNUAL_BUDGET,
	COLUMNS.ACTUAL_ANNUAL_SPEND,
	COLUMNS.FORECAST_ANNUAL_BUDGET,
];

const monthPrefixes = [
	'ORIGINAL_BUDGET_MONTH_',
	'FORECAST_BUDGET_MONTH_',
	'ACTUAL_SPEND_MONTH_',
];

const prefixByAggregatedColumn = {
	[COLUMNS.ORIGINAL_ANNUAL_BUDGET]: monthPrefixes[0],
	[COLUMNS.FORECAST_ANNUAL_BUDGET]: monthPrefixes[1],
	[COLUMNS.ACTUAL_ANNUAL_SPEND]: monthPrefixes[2],
};

const aggregatedColumnByPrefix = {
	[prefixByAggregatedColumn.ORIGINAL_ANNUAL_BUDGET]:
		COLUMNS.ORIGINAL_ANNUAL_BUDGET,
	[prefixByAggregatedColumn.ACTUAL_ANNUAL_SPEND]: COLUMNS.ACTUAL_ANNUAL_SPEND,
	[prefixByAggregatedColumn.FORECAST_ANNUAL_BUDGET]:
		COLUMNS.FORECAST_ANNUAL_BUDGET,
};

export const calculateBudgetData = (colId, data, monthCount) => {
	if (aggregatedColumns.includes(colId)) {
		const averageByMonth = Math.round((data[colId] / monthCount) * 100) / 100;
		const updates = [...Array(monthCount)].reduce((acc, _, i) => {
			return {
				...acc,
				[`${prefixByAggregatedColumn[colId]}${i + 1}`]: averageByMonth,
			};
		}, {});

		return { ...data, ...updates };
	}

	const prefix = monthPrefixes.find(item => colId.indexOf(item) !== -1);

	if (prefix) {
		const annual = [...Array(monthCount)].reduce((acc, _, i) => {
			const column = `${prefix}${i + 1}`;

			return Math.round((acc + data[column] || 0) * 100) / 100;
		}, 0);

		return {
			...data,
			[aggregatedColumnByPrefix[prefix]]: annual,
		};
	}

	return data;
};

const NEW_COST_CENTRE_VALUE = 'COST_CENTRE_NEW';

export const DEFAULT_NEW_ROW_DATA = {
	[COLUMNS.GL_CODE]: 'GL_CODE_NEW',
	[COLUMNS.BUDGET_OWNER]: 'BUDGET_OWNER',
	[COLUMNS.COST_CENTRE]: NEW_COST_CENTRE_VALUE,
};

export const getDefaultNewRow = monthCount => {
	return {
		...DEFAULT_NEW_ROW_DATA,
		...[...Array(monthCount)].reduce((acc, _, i) => {
			return {
				...acc,
				...monthPrefixes.reduce((monthsAcc, prefix) => {
					return { ...monthsAcc, [`${prefix}${i + 1}`]: null };
				}, {}),
			};
		}, {}),
	};
};

export const getRowDataForSave = rows => {
	if (!rows) {
		return [];
	}

	return rows.map(row => {
		const months = Object.keys(row)
			.filter(key => monthPrefixes.some(str => key.includes(str)))
			.reduce((acc, key) => {
				return { ...acc, [key]: row[key] };
			}, {});

		return {
			...row,
			months,
		};
	});
};
